const columns = [
  {
    dataField: 'order_id',
    text: 'Order ID',
    localizationSlug: 'ORDER_ID',
    type: 'entity',
    entityType: 'order',
    hideable: false,
    sort: true,
  },
  {
    dataField: 'status',
    text: 'Status',
    localizationSlug: 'STATUS',
    type: 'status',
    hideable: true,
    sort: true,
  },
  {
    dataField: 'steamship_or_railroad',
    text: 'Steamship / Railroad',
    localizationSlug: 'STEAMSHIP_RAILROAD',
    hideable: true,
    sort: true,
  },
  {
    dataField: 'vessel_or_rail',
    text: 'Vessel / Train',
    localizationSlug: 'VESSEL_TRAIN',
    hideable: true,
    sort: true,
  },
  {
    dataField: 'reference_numbers',
    text: 'Reference Numbers',
    localizationSlug: 'REFERENCE_NUMBERS',
    type: 'reference_number',
    hideable: true,
    sort: false,
    headerStyle: {
      width: "15%",
    },
  },
  {
    dataField: 'shipper',
    text: 'Shipper',
    localizationSlug: 'SHIPPER',
    type: 'customer',
    hideable: true,
    sort: true,
  },
  {
    dataField: 'carrier',
    text: 'Carrier',
    localizationSlug: 'CARRIER',
    type: 'customer',
    sort: true,
    hideable: true,
  },
  {
    dataField: 'arriving[0]',
    text: 'Arriving',
    localizationSlug: 'ARRIVING',
    type: 'location',
    sort: true,
    hideable: true,
  },
  {
    dataField: 'delivering[0]',
    text: 'Delivering',
    localizationSlug: 'DELIVERING',
    type: 'location',
    hideable: true,
    sort: true,
  },
  {
    dataField: 'movement_type',
    text: 'Movement Type',
    localizationSlug: 'MOVEMENT_TYPE',
    hideable: true,
    sort: true,
  },
  {
    dataField: 'order_type',
    text: 'Type',
    localizationSlug: 'TYPE',
    type: 'order_type',
    hideable: true,
    sort: true,
  },
  {
    dataField: 'estimated_arrival',
    text: 'ETA',
    localizationSlug: 'ETA',
    type: 'datetime',
    hideable: true,
    sort: true,
  },
  {
    dataField: 'arrival_date',
    text: 'Arrived',
    localizationSlug: 'ARRIVED',
    type: 'datetime',
    hideable: true,
    sort: true,
  },
  {
    dataField: 'outstanding_ar',
    text: 'Outstanding AR',
    localizationSlug: 'OUTSTANDING_AR',
    type: 'currency',
    hideable: true,
  },
  {
    dataField: 'outstanding_ap',
    text: 'Outstanding AP',
    localizationSlug: 'OUTSTANDING_AP',
    type: 'currency',
    hideable: true,
  },
  {
    dataField: 'equipments',
    text: 'Equipments',
    localizationSlug: 'EQUIPMENTS',
    type: 'equipments',
    hideable: true,
    sort: false,
    headerStyle: {
      width: "8%",
    }
  },
  {
    dataField: 'last_free_date',
    text: 'Last Free Day',
    localizationSlug: 'LAST_FREE_DAY',
    type: 'datetime',
    hideable: true,
    sort: true,
  },
  {
    dataField: 'missing_docs',
    text: 'Missing POD',
    localizationSlug: 'MISSING_POD',
    type: 'boolean',
    hideable: true,
    sort: true,
  },
  {
    dataField: 'invoices',
    text: 'Invoice Sent',
    localizationSlug: 'INVOICE_SENT',
    type: 'invoice',
    hideable: true,
    sort: true,
  },
];

export default {
  columns,
};
